<template>
  <page :manualInit="claimEntry.init" :manualErr="claimEntry.initErr" @reload="doInit">
    <template slot="pageAction">
      <div v-if="$store.state.claims.claimDetail.saving" class="actionBlock">
        <v-progress-circular indeterminate color="primary" :size="20"></v-progress-circular>
        <span class="pl-2">Saving...</span>
      </div>
      <div class="actionBlock" v-if="showStatusBtn">
        <v-tooltip bottom>
          <v-btn flat color="secondary" @click="lifeCycle = !lifeCycle" slot="activator">
            Status Overview
            <v-icon right>mdi-file-document-box</v-icon>
          </v-btn>
          <span>Status Overview</span>
        </v-tooltip>
      </div>
    </template>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view :toggleQuery="toggleQuery"></router-view>
      </transition>
    </div>
    <v-navigation-drawer temporary fixed clipped right app v-model="lifeCycle" width="400">
      <life-cycle :query="query"></life-cycle>
    </v-navigation-drawer>
    <v-dialog v-model="saveError" width="800px" lazy>
      <save-error-dialog @close="saveError = false"></save-error-dialog>
    </v-dialog>
    <div class="mt-3" v-if="renderComments">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex lg8 xs12 order-lg1 order-xs2>
            <comments></comments>
          </v-flex>
          <v-flex lg8 xs12 order-lg1 order-xs2>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </page>
</template>

<script>
import LifeCycle from './LifeCycle'
import SaveErrorDialog from './SaveErrorDialog'
import routeMixin from '@/mixins/route'
import Comments from './Comments'

export default {
  data() {
    return {
      lifeCycle: false,
      saveError: false,
      query: false
    }
  },
  watch: {
    'saveErrorMsg': {
      handler: function (value) {
        if ((value.messages && value.messages.length > 0) || (value.fieldMessages && value.fieldMessages.length > 0)) {
          this.saveError = true
        }
      },
      deep: true
    }
  },
  computed: {
    claimEntry() {
      return this.$store.state.claims.claimEntry
    },
    saveErrorMsg() {
      return this.$store.state.claims.claimDetail.saveError
    },
    showStatusBtn() {
      // We only want to show at specific module page
      if (this.isMatchRoute('claimEntry')) {
        return false
      } else {
        return true
      }
    },
    renderComments() {
      if (this.$route.name !== 'claimEntry') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('claimEntryInit')
    },
    toggleQuery(isQueryMode = false) {
      this.query = isQueryMode
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    LifeCycle,
    SaveErrorDialog,
    Comments
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
// Side info for all quotation
.quoteSideInfo {
  // Overwrite toolbar margin on side info
  .toolbar__content > *:not(.btn):not(.menu):last-child,
  .toolbar__extension > *:not(.btn):not(.menu):last-child {
    margin-right: 0px;
  }
}
// Internal quotation lifecycle for all quotation
.quoteLifeCycle {
  &.v-stepper {
    background: none !important;
    box-shadow: none !important;
  }
}
</style>
